import React, { useState } from "react";
import { TextBox } from "devextreme-react";
import PropTypes from "prop-types";
import "./CustomTextBox.scss";

const CustomTextBox = ({
  label,
  placeholder,
  value,
  onChange,
  type,
  readOnly=false,
  width = "100%",
  noRequired
}) => {
  const [passwordVisible, setPasswordVisible] = useState(true);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  return (
    <div className="MyTextBox" >
      {label && (
        <>
          <label className="TextBoxLabel">
            {label} <span className="requiredClass">{noRequired==="no" ? "" : "*"}</span>
          </label>
        </>
      )}

      <div className="TextBoxWrapper">
        <TextBox
          value={value}
          onValueChanged={onChange}
          width={width}
          stylingMode="outlined"
          className="TextBoxMain"
          placeholder={placeholder}
          readOnly={readOnly}
          mode={passwordVisible && type === "password" ? "password" : "text"}
        />
        {type === "password" && (
          <span className="eye-icon" onClick={togglePasswordVisibility}>
            <i
              className={passwordVisible ? "ri-eye-off-line" : "ri-eye-line"}
            ></i>
          </span>
        )}
      </div>
    </div>
  );
};

// CustomTextBox.propTypes = {
//   label: PropTypes.string.isRequired,
//   placeholder: PropTypes.string.isRequired,
//   value: PropTypes.string.isRequired,
//   onChange: PropTypes.func.isRequired,
//   type: PropTypes.string,
// };

export default CustomTextBox;
